import styled from 'styled-components';
import {ListTitleTextDefaultBox} from './list-title-text.default.box';
import { JACKPOT_WIDGET, RED_TIGER_JACKPOT } from '../../constants';

export const ListTitleTextSiBox = styled(ListTitleTextDefaultBox)`
    letter-spacing: 0.1rem;
    
    background-image: linear-gradient(to right, ${props => props.theme.colors.background} 0%, ${props => props.theme.colors.background} 70%, ${props => props.theme.colors.background}00 100%);
    background-color: transparent;

    .${JACKPOT_WIDGET} & {
        border-left: 5px solid ${props => props.theme.colors.brandPrimary};
    }

    .${RED_TIGER_JACKPOT} & {
        border-left: 5px solid ${props => props.theme.colors.brandPrimary};
    }
`;
